import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const getListWaitHappy = (dealer) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/happyWaiting/list?dealer=${dealer}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_LIST_WAIT_HAPPY,
        ActionTypes.FETCHED_LIST_WAIT_HAPPY,
        [ActionTypes.FETCHED_LIST_WAIT_HAPPY_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};


export const getWeekListWaitHappy = (id) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/happyWaiting/weeks?id=${id}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_LIST_WEEK_WAIT_HAPPY,
        ActionTypes.FETCHED_LIST_WEEK_WAIT_HAPPY,
        [ActionTypes.FETCHED_LIST_WEEK_WAIT_HAPPY_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

